export class ObjectUtils {
    static assign <T>(target: T, ...partials: Partial<T>[]): T {
        partials.forEach(partial => {
            Object.keys(target).forEach(prop => partial[prop] !== undefined && (target[prop] = partial[prop]));
        })
        return target;
    }
}
